
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/components/ui/use-toast";

export default function ProfileTab() {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      toast({
        title: "Profile updated",
        description: "Your profile information has been saved successfully.",
      });
    }, 1000);
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h2 className="text-2xl font-semibold text-white mb-2">Profile Settings</h2>
        <p className="text-stewie-gray">
          Manage your personal information and how your profile appears to others.
        </p>
      </div>

      <div className="settings-card">
        <h3 className="settings-header">Profile Picture</h3>
        
        <div className="flex items-center gap-4">
          <div className="relative">
            <div className="h-24 w-24 rounded-full bg-gradient-to-br from-stewie-blue to-stewie-accent flex items-center justify-center text-white text-2xl font-bold">
              ST
            </div>
            <div className="absolute -bottom-1 -right-1 bg-stewie-blue rounded-full p-1">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="text-white">
                <path d="M16 3H8a2 2 0 00-2 2v14a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 15v-6M9 12h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>
          
          <div>
            <Button variant="outline" className="bg-stewie-dark text-white border-stewie-gray/30 hover:bg-stewie-gray/20">
              Change Photo
            </Button>
            <p className="text-xs text-stewie-gray mt-2">
              Recommended: Square image, at least 400x400px
            </p>
          </div>
        </div>
      </div>

      <form className="settings-card" onSubmit={handleSubmit}>
        <h3 className="settings-header">Personal Information</h3>
        
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="fullName" className="text-white">Full Name</Label>
              <Input
                id="fullName"
                placeholder="Your full name"
                defaultValue="Stewie Trader"
                className="bg-stewie-dark border-stewie-gray/30 text-white"
              />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="displayName" className="text-white">Display Name</Label>
              <Input
                id="displayName"
                placeholder="Your display name"
                defaultValue="Stewie"
                className="bg-stewie-dark border-stewie-gray/30 text-white"
              />
            </div>
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="email" className="text-white">Email Address</Label>
            <Input
              id="email"
              type="email"
              placeholder="Your email address"
              defaultValue="user@stewietrader.com"
              disabled
              className="bg-stewie-dark border-stewie-gray/30 text-stewie-gray"
            />
            <p className="text-xs text-stewie-gray">
              Email address cannot be changed. Contact support for assistance.
            </p>
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="bio" className="text-white">Bio</Label>
            <Textarea
              id="bio"
              placeholder="Write a brief bio about yourself"
              defaultValue="Financial analyst and algorithmic trader specializing in high-frequency trading strategies."
              className="bg-stewie-dark border-stewie-gray/30 text-white min-h-[120px]"
            />
          </div>
          
          <div className="pt-4 flex justify-end">
            <Button type="submit" disabled={isLoading} className="bg-stewie-blue hover:bg-stewie-blue/80">
              {isLoading ? (
                <span className="flex items-center gap-2">
                  <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Saving...
                </span>
              ) : (
                "Save Changes"
              )}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
